// extracted by mini-css-extract-plugin
export default {"container":"cop_2A0Qv","button":"cop_but_2B0_P","icon":"cop_ico_qDpTP"};